/**
 * One entry of a storage toolbar's More menu (UI/UX fix round A, review A4): a real `DropdownMenuItem`, so arrow keys
 * reach it, Enter / click runs it and the menu closes before the dialog it opens. An unavailable entry stays focusable
 * (`aria-disabled`, `reasonMenuItemProps`) and shows its reason as a second line.
 */
import { DropdownMenuItem } from '../../../../components/ui/dropdown-menu';
import { reasonMenuItemProps } from '../../../../components/ui/reasonMenuItem';
import { StorageMenuItemContent, type StorageMenuItemContentProps } from './StorageMenuItemContent';

export type StorageToolbarMenuItemProps = StorageMenuItemContentProps & { onSelect: () => void; testId: string };

export function StorageToolbarMenuItem({ onSelect, testId, ...content }: StorageToolbarMenuItemProps) {
  const inert = reasonMenuItemProps(content.reason);
  return (
    <DropdownMenuItem {...inert} onSelect={content.reason ? inert.onSelect : onSelect} data-testid={testId}>
      <StorageMenuItemContent {...content} />
    </DropdownMenuItem>
  );
}
